import Search from './search';
import Chats from './chats';
import ChatFilter from './components/chat-filter';
import MetadataDropdown from '../../components/MetaData-Selector';

const Sidebar = () => {
  return (
    <div className="__sidebar flex flex-column">
      <div className="p-3 border-bottom-1 surface-border">
        <MetadataDropdown />
      </div>
      <Search />
      {/* <ChatFilter /> */}
      <Chats />
    </div>
  );
};

export default Sidebar;
